import React from "react";

const logos = [
  { name: "Cisco", src: "/assets/logos/cisco.png" },
  { name: "Fortinet", src: "/assets/logos/fortinet.png" },
  { name: "Dell", src: "/assets/logos/dell.png" },
  { name: "HP", src: "/assets/logos/hp.png" },
  { name: "Microsoft", src: "/assets/logos/microsoft.png" },
  { name: "hikvision", src: "/assets/logos/hikvision.png" },
  { name: "aruba", src: "/assets/logos/aruba.png" },
  { name: "dlink", src: "/assets/logos/dlinl.png" },
];

const TrustedLogos = () => {
  return (
    <section className="bg-white py-12 px-6">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-700 mb-8">
          Trusted by Industry Leaders
        </h2>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-6 items-center justify-center">
          {logos.map((logo, index) => (
            <div key={index} className="flex items-center justify-center grayscale hover:grayscale-0 transition">
              <img
                src={logo.src}
                alt={logo.name}
                className="h-12 object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedLogos;
